import * as React from "react";

import { NavigationList } from "./navigation-list-component";
import {
  OverflowWrapper,
  ShadowWrapper,
  StyledNavigationMenu,
} from "./navigation-menu-component-styles";

type NavigationMenuProps = {
  menu?: React.ReactNode;
  cta?: React.ReactNode;
  isCentered: boolean;
};

export function NavigationMenu({ cta, menu, isCentered }: NavigationMenuProps) {
  return (
    <StyledNavigationMenu className="navigation-menu">
      <ShadowWrapper className="shadow-wrapper">
        <OverflowWrapper>
          <NavigationList isCentered={isCentered} menu={menu} />
        </OverflowWrapper>
      </ShadowWrapper>
      {cta}
    </StyledNavigationMenu>
  );
}
